import { render, staticRenderFns } from "./RetailerSignUp.vue?vue&type=template&id=707c7550&scoped=true&lang=pug"
import script from "./RetailerSignUp.vue?vue&type=script&lang=js"
export * from "./RetailerSignUp.vue?vue&type=script&lang=js"
import style0 from "./RetailerSignUp.vue?vue&type=style&index=0&id=707c7550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c7550",
  null
  
)

export default component.exports